import daily from '@/components/daily/Daily'

export default [
  {
    path: '/daily',
    name: 'daily',
    component: daily,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/daily.js